/**
 * Finds the article level object that shares the levelId
 * @param {array} articleStory
 * @param {string} levelId
 * @returns {{content_id: String, header_id: String, id: Number, slug: String}}
 */
const getMatchingLegacyArticleLevel = (articleStory, levelId) => {
  if (!articleStory || !levelId) return;

  const [articleHeaders] = articleStory;

  const matchingArticleLevel = articleHeaders?.article_levels?.find(
    (articleLevel) => {
      return articleLevel?.content_id === levelId;
    },
  );

  return matchingArticleLevel
    ? { ...matchingArticleLevel, slug: articleHeaders?.slug }
    : undefined;
};

export default getMatchingLegacyArticleLevel;
